import { render, staticRenderFns } from "./modal_iniciar_consulta.vue?vue&type=template&id=67fb6654&scoped=true"
import script from "./modal_iniciar_consulta.vue?vue&type=script&lang=js"
export * from "./modal_iniciar_consulta.vue?vue&type=script&lang=js"
import style0 from "./modal_iniciar_consulta.vue?vue&type=style&index=0&id=67fb6654&prod&scoped=true&lang=css"
import style1 from "./modal_iniciar_consulta.vue?vue&type=style&index=1&id=67fb6654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb6654",
  null
  
)

export default component.exports